<template>
    <div>
        <h2>Your brokerage</h2>

        <div class="signup-form__field">
            <label for="signup-brokerage" class="signup-form__label">Brokerage name <span class="signup-form__required">*</span></label>
            <input
                type="text"
                class="signup-form__input"
                id="signup-brokerage"
                v-model="state.form.brokerage"
                required
                autocomplete="organization"
            />
            <span v-if="error('brokerage')" class="signup-form__error" role="alert">{{ error('brokerage') }}</span>
        </div>

        <div class="signup-form__field">
            <label for="signup-principal-name" class="signup-form__label">Principal broker name <span class="signup-form__required">*</span></label>
            <input
                type="text"
                class="signup-form__input"
                id="signup-principal-name"
                v-model="state.form.principalBrokerName"
                required
            />
            <span v-if="error('principalBrokerName')" class="signup-form__error" role="alert">{{ error('principalBrokerName') }}</span>
        </div>

        <div class="signup-form__field">
            <label for="signup-principal-email" class="signup-form__label">Principal broker email <span class="signup-form__required">*</span></label>
            <input
                type="email"
                class="signup-form__input"
                id="signup-principal-email"
                v-model="state.form.principalBrokerEmail"
                required
            />
            <span v-if="error('principalBrokerEmail')" class="signup-form__error" role="alert">{{ error('principalBrokerEmail') }}</span>
        </div>

        <div class="signup-form__field">
            <label for="signup-website" class="signup-form__label">
                Your website URL
            </label>
            <input
                type="text"
                class="signup-form__input"
                id="signup-website"
                v-model="state.form.website"
                autocomplete="url"
            />
            <span v-if="error('website')" class="signup-form__error" role="alert">{{ error('website') }}</span>
        </div>

        <template v-if="!buildingForThem">
            <div class="signup-form__field">
                <label for="signup-website-builder" class="signup-form__label">Website builder</label>
                <select
                    class="signup-form__input"
                    id="signup-website-builder"
                    v-model="state.form.websiteBuilder"
                >
                    <option value="">— Select —</option>
                    <option value="wordpress">WordPress</option>
                    <option value="squarespace">Squarespace</option>
                    <option value="wix">Wix</option>
                    <option value="other">Other</option>
                </select>
                <span v-if="error('websiteBuilder')" class="signup-form__error" role="alert">{{ error('websiteBuilder') }}</span>
            </div>

            <div v-if="state.form.websiteBuilder === 'other'" class="signup-form__field">
                <label for="signup-website-builder-other" class="signup-form__label">Which builder?</label>
                <input
                    type="text"
                    class="signup-form__input"
                    id="signup-website-builder-other"
                    v-model="state.form.websiteBuilderOther"
                />
                <span v-if="error('websiteBuilderOther')" class="signup-form__error" role="alert">{{ error('websiteBuilderOther') }}</span>
            </div>
        </template>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import useState from '@/composables/useState';

const { state } = useState();

// When the agent has chosen the Website Builder addon we're building their site,
// so asking what platform they're on doesn't make sense — just collect the
// domain they want us to point at.
const buildingForThem = computed(() => state.form.addonCodes.includes('website_builder'));

const error = (field) => state.serverErrors[field]?.[0];
</script>
